<template>
  <NodeId :node_id="$route.params.node_id"/>
</template>
<script>
import NodeId from "@/components/admin/nodes/NodeId";
export default {
  components: {NodeId}
}
</script>
